// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqMyQuotesHeaderStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

rfqMyQuotesHeaderStyles.container = {
    gap: 0,
};

rfqMyQuotesHeaderStyles.quoteCountGridItem = {
    width: [12, 2, 2, 2, 2],
    css: css`
        font-size: 14px;
        font-weight: bold;
        align-items: center;
        text-transform: capitalize;
        order: 2;

        &,
        & > div {
            text-align: right;
            justify-content: flex-end;
        }

        ${xScreen("lte", "xs")} {
            order: 1;
            padding-bottom: 4px;
            &,
            & > div {
                text-align: left;
                justify-content: flex-start;
            }
        }
    `,
};

rfqMyQuotesHeaderStyles.quoteCountText = {
    weight: "bold",
};

rfqMyQuotesHeaderStyles.toggleFilterGridItem = {
    width: [12, 10, 10, 10, 10],
    css: css`
        order: 1;
        ${xScreen("lte", "xs")} {
            order: 2;
        }
    `,
};

rfqMyQuotesHeaderStyles.statusFilterGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        padding-right: 20px;
        ${xScreen("lte", "sm")} {
            padding-right: 0;
        }
        & > div {
            margin-bottom: 20px;
            max-width: 450px;
        }
    `,
};

rfqMyQuotesHeaderStyles.typeFilterGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        & > div {
            margin-bottom: 20px;
            max-width: 450px;
        }
    `,
};
